export const FIELD_LABEL_MAP = {
  f_name: 'First name',
  l_name: 'Last name',
  m_name: 'Middle name',
  p_name: 'Preferred name',
  dob: 'Date of birth',
  ssn: 'SSN',
  email: 'Email',
  alt_email: 'Alternative email',
  phone: 'Phone',
  cell_phone: 'Cell phone',
  home_phone: 'Home phone',
  work_phone: 'Work phone',
  gender: 'Gender',
  pronoun: 'Pronoun',
  prefix: 'Prefix',
  suffix: 'Suffix',
  marital_status: 'Marital status',
  race: 'Race',
  ethnicity: 'Ethnicity',
  language: 'Language',
  emergency_contact: 'Emergency contact',
  secondary_emergency_contact: 'Secondary emergency contact',
  two_factor_enabled: 'Two-factor authentication',
  pt_balance: 'Patient balance',
  primary_doctor: 'Primary doctor',
  notification_preferences: 'Notification preferences',
  display_settings: 'Display settings',
  about_me: 'About me',
  profile_photo: 'Profile photo',
  status: 'Status',
  portal: 'Portal access',
  type: 'Account type',
  occupation: 'Occupation',
  timezone: 'Timezone',
  drivers_license: "Driver's license",
  date_last_seen: 'Date last seen',
  acute_manifest_date: 'Acute manifest date',
  accident_date: 'Accident date',
  initial_treatment_date: 'Initial treatment date',
  last_menstrual_period: 'Last menstrual period',
  last_xray: 'Last x-ray',
  assumed_care_date: 'Assumed care date',
  relinquished_care_date: 'Relinquished care date',
  last_worked_date: 'Last worked date',
  disability_from_date: 'Disability from date',
  disability_thru_date: 'Disability thru date',
  hearing_vision_rx_date: 'Hearing and vision prescription date',
  authorized_return_to_work_date: 'Authorized return to work date',
  first_contact_date: 'First contact date',
  patient_death_date: 'Patient death date',
  // Insurance profile
  payer_name: 'Payer name',
  member_id: 'Member ID',
  group_number: 'Group number',
  plan_name: 'Plan name',
  policy_start_date: 'Policy start date',
  policy_end_date: 'Policy end date',
  relation: 'Relation to insured',
  card_front: 'Insurance card front',
  card_back: 'Insurance card back',
  ignore_warnings: 'Ignore warnings',
  other_relation_name: 'Other relation name',
  other_relation_date: 'Other relation date',
  other_relation_phone: 'Other relation phone',
  // Guarantor
  relationship: 'Relationship',
  // Pharmacy
  fax_number: 'Fax number',
  // Referring provider / Supervising provider
  npi: 'NPI',
  cond_date: 'Condition date',
  prov_id: 'Provider ID',
  // Practice patient
  custom_chart_id: 'Custom chart ID',
  sms_consent: 'SMS consent',
  decease_date: 'Deceased date',
  decease_reason: 'Deceased reason',
  virtual_link: 'Virtual link',
  // Address
  address_ln_1: 'Address line 1',
  address_ln_2: 'Address line 2',
  city: 'City',
  zip: 'Zip code',
  // Appointment
  appointment_type_id: 'Appointment type',
  color: 'Color',
  duration: 'Duration',
  ends_at: 'End time',
  location_id: 'Location',
  notes: 'Notes',
  practice_note: 'Practice note',
  practitioner: 'Provider',
  practitioner_id: 'Provider',
  progress: 'Progress',
  resource: 'Resource',
  resources: 'Resources',
  starts_at: 'Start time',
  tag_ids: 'Appointment tags',
  added_tag: 'Added tag',
  added_tags: 'Added tags',
  removed_tag: 'Removed tag',
  removed_tags: 'Removed tags',
  // Invoice / services
  total_amount: 'Appointment subtotal',
  balance: 'Appointment total',
  added_service: 'Added service',
  added_services: 'Added services',
  added_product: 'Added product',
  added_products: 'Added products',
  removed_service: 'Removed service',
  removed_services: 'Removed services',
  removed_product: 'Removed product',
  removed_products: 'Removed products',
  updated_service: 'Updated service',
  self_pay_amount: 'Self pay amount',
  est_patient_portion: 'Est. patient portion',
  allowed_amount: 'Allowed amount',
  insurance_payment: 'Insurance payment',
  service_discount: 'Discount',
  tax: 'Total appointment tax',
  state_tax: 'State tax rate',
  local_tax: 'Local tax rate',
  quantity: 'Quantity',
  unit_price: 'Unit price',
  product_total: 'Product total'
};

// Fields whose values are ISO datetime strings and should be formatted with timezone
export const DATE_TIME_FIELDS = ['starts_at', 'ends_at'];
